// extracted by mini-css-extract-plugin
module.exports = {"banner":"Home_banner_FCiGs"};